import CssBaseline from '@mui/material/CssBaseline';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { ThemeProvider } from '@mui/material/styles';
import 'aws';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet';
import 'whatwg-fetch';

import { Toaster } from 'DesignSystem/ui/toaster';
import { getLaunchDarklyContextFromSession } from 'utils/launchDarklyClient';

import { App } from './App';
import './index.css';
import './instrument';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

const tagManagerArgs = {
  gtmId: 'GTM-PVGVSVV',
};

if (process.env.VITE_DEPLOY_ENV !== 'development') {
  // Google Tag Manager
  TagManager.initialize(tagManagerArgs);
}

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

const renderApp = async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID,
    context: await getLaunchDarklyContextFromSession(),
    options: { bootstrap: 'localStorage' },
  });

  root.render(
    <LDProvider>
      <StyledEngineProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Helmet titleTemplate="%s | Clarium" />
          <App />
          <Toaster />
        </ThemeProvider>
      </StyledEngineProvider>
    </LDProvider>
  );
};

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
